import type { FileIconThemeManifest } from "../contracts";

export function createFileIconThemeRegistry(
    manifests: FileIconThemeManifest[],
): Map<string, FileIconThemeManifest> {
    return new Map(manifests.map((manifest) => [manifest.id, manifest]));
}
